import { colors } from '@alixpartners/ui-components';

export const STATE_COLORS = {
  Uploaded: colors.cyan600,
  Mapping: colors.amber600,
  Staged: colors.grey500,
  Downloading: colors.amber600,
  Deleted: colors.amber600,
};

export const STATE_HEADINGS = {
  Uploaded: 'Uploaded',
  Mapping: 'Incomplete mapping session',
  Staged: 'Mapped to schema and copied to staging table',
  Downloading: 'Incomplete mapping session',
};

export const BACKGROUND_COLORS = {
  Uploaded: '#ffffff',
  Mapping: colors.amber100,
  Staged: 'transparent',
  Downloading: colors.amber100,
  Deleted: colors.red100,
};

export const ICON_NAMES = {
  Uploaded: 'cloud_done',
  Mapping: 'pause',
  Staged: 'done_all',
  Downloading: 'pause',
  Deleted: 'cloud_done',
};
